import type { PointerEvent } from '@/core/utils/touch'

export const isMultiSelectEvent = (event: PointerEvent): boolean =>
  (event.ctrlKey || event.metaKey) && (!(event instanceof MouseEvent) || event.button === 0)

export const isRangeSelectEvent = (event: PointerEvent): boolean =>
  (event.ctrlKey || event.metaKey) &&
  event.shiftKey &&
  (!(event instanceof MouseEvent) || event.button === 0)
